import React, { useState } from "react"
import i18n from "i18n"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"

import { WHATSAPP_NUMBER } from "constants/common"

const EntitlementDialogGuard = ({ title, content, onClose }) => {
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
    if (onClose) onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {title}
        <IconButton
          aria-label={i18n.t("entitlements.freeDemo")}
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          component="a"
          href={`https://api.whatsapp.com/send/?phone=${WHATSAPP_NUMBER}&text=%C2%A1Quiero%20probar%20un%20plan%20superior!&type=phone_number&app_absent=0`}
          color="primary"
          variant="outlined"
          target="_blank"
          rel="noopener"
        >
          {i18n.t("entitlements.requestDemo")}
        </Button>
        <Button
          component={Link}
          to="/subscription"
          color="branded"
          variant="contained"
          autoFocus
          target="_blank"
          rel="noopener"
        >
          {i18n.t("entitlements.upgradePlan")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

EntitlementDialogGuard.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

export default EntitlementDialogGuard
